import { enableAutoEventAnalytics } from "@oddcamp/analytics"

enableAutoEventAnalytics()
